import { InputKeyPair } from 'types/common'

export const getNestedErrorMessage = (
  errors: Record<string, any>,
  inputKey: InputKeyPair,
) => {
  return errors?.[inputKey.parentKey]?.[inputKey.key]?.message
}
